import moment from "moment";
import React from 'react'
const json = {
    admission_date: moment(new Date()).format("DD-MM-YYYY"),
    discharge_date: moment(new Date()).format("DD-MM-YYYY"),
    discharge_status: '',
    discharge_type: '',
    history: '',
    chief_complaint: '',
    hr: '',
    rr: '',
    pr:'',
    bp: '',
    bt: '',
    sat: '',
    other: '',
    gcs_e: '',
    gcs_v: '',
    gcs_m: '',
    inv_eFAST: '',
    inv_p_cxr: '',
    inv_other: '',
    management: '',
    operation: '',
    findings: '',
    principal_diagnosis: '',
    other_problems: '',
    hosital_course: '',
    complication: '',
    home_medications: '',
    appointment: '',
    iss_head: '',
    iss_chest: '',
    iss_external: '',
    iss_face: '',
    iss_abdomen: '',
    iss_extremity: '',
    iss_rr: '',
    mechanism_injury: 'p',
    patient_id: '',
    visit_id  :'',
    admission_id: '',
    discharge_id : '',
    name:'',
    surname: '',
    address: '',
    citizen_id: '',
    gender: '',
    id : '',
    hn:'',
    an:'',
    iss:0,
    ward:'',
    staff_name :'',
    staff_id :'',
    resident_name :'',
    division :'Trauma',
    record_name :'',
    recode_code :'',
    record_datetime :  moment(new Date()).format("DD-MM-YYYY H:mm"),
    birth_date : '',
    admission_date_age : '',
    age : 0,
    stay:0,
    rts:0,
    triss:0,
    bp_s : '',
    bp_d : '',
    gsc_all : 0,
    ais_1 : '',
    ais_2 : '',
    ais_3 : '',
    ais_4 : '',
    ais_5 : '',
    ais_6 : '',
    ais_7 : '',
    ais_8 : '',
    ais_9 : '',
    ais_10 : '',
    ais_11 : '',
    ais_12 : '',
    ais_13: '',
    ais_14: '',
    ais_15: '',
    ais_16: '',
    ais_17: '',
    ais_18: '',
    ais_19: '',
    ais_20: '',
    ais_21: '',
    ais_22: '',


}

export default json;
